import { createFileRoute } from "@tanstack/react-router";
import Mais from "@/pages/admin/Mais";
import { pageHead } from "@/lib/seo";

// Aba "Mais" do celular: as seções que não cabem na barra de baixo, como uma lista dos Ajustes do iPhone.
export const Route = createFileRoute("/admin/mais")({
  head: () => pageHead({ title: "Mais | Painel", path: "/admin/mais", noindex: true }),
  component: Mais,
});
